import Vue from 'vue'
import App from './App.vue'
import vuetify from '@/plugins/vuetify'
import Vuex from 'vuex'
import store from '@/store'
import router from '@/router'
import Moment from 'vue-moment';
import moment from 'moment';
import roleMixins from './mixins/role-mixins'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(Moment);
Vue.filter('localMoment', function (date, format) {
  return moment.utc(date).local().format(format)
})

Vue.mixin(roleMixins)

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
